import { nextCargoApi } from "@/store/apis/baseApi";
import { startAppListening } from "@/store/utils";

import { settingsSliceActions } from "../settings";
import { authSlice } from "./auth.slice";

startAppListening({
  matcher: authSlice.actions.logout.match,
  effect: (action, { dispatch, getState }) => {
    const store = getState();

    if (store.nextCargo) {
      dispatch(nextCargoApi.util.resetApiState());
      dispatch(settingsSliceActions.clearSettings());
    }
  }
});
